<template>
  <div class="resource-card">
    <div>
      <img :src="logo" class="img-fluid mb-2" alt="Logo Not Found" style="width: 76px" />
      <h5>{{ name }}</h5>
    </div>
    <p>{{ description }}</p>
    <a :href="url" target="_blank">Visit Website</a>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    url: String,
    logo: String,
    description: String,
  },
};
</script>

<style scoped>
.resource-card {
  border: 1px solid #ccc;
  padding: 20px;
  width: 300px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

/* Add your CSS styling for the ResourceCard component here */
</style>
